import { Button } from "antd";
import dayjs from "dayjs";
import React, { useCallback, useMemo, useState } from "react";
import { useVenueService } from "~pages/Venues/hooks/useVenueService.ts";
import HistoricNames, { AddHistoricNameModal } from "../HistoricalNames";
import PersonHistoricNames from "../Person/PersonHistoricNames";

const NameComponent = ({ value }) => {
  return <>{value}</>;
};

const EditButton = ({ historicalNames, row, handleUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <AddHistoricNameModal
        historicalNames={historicalNames}
        defaultName={row.nameLocal}
        defaultStartDate={dayjs(row.dateStart)}
        defaultEndDate={dayjs(row.dateEnd)}
        isAddModalOpen={isModalOpen}
        setIsAddModalOpen={setIsModalOpen}
        isEditMode={true}
        handleUpdate={handleUpdate}
        modalTitle={"venues.name"}
      />
      <Button
        outline
        color="primary"
        size="sm"
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <i className="fas fa-pen" />
      </Button>
    </>
  );
};

const columns = (historicalNames, handleUpdate) => [
  {
    title: "Venue Name",
    dataIndex: "nameLocal",
    key: "nameLocal",
    render: (value) => <NameComponent value={value} />,
  },
  {
    title: "Start Date",
    dataIndex: "dateStart",
    key: "dateStart",
    render: (value) => <div>{dayjs(value).format("DD-MM-YYYY")}</div>,
  },
  {
    title: "End Date",
    dataIndex: "dateEnd",
    key: "dateEnd",
    render: (value) => <div>{dayjs(value).format("DD-MM-YYYY")}</div>,
  },
  {
    render: (_, row) => <EditButton historicalNames={historicalNames} row={row} handleUpdate={handleUpdate} />,
  },
];

const VenuesHistoricNames = ({ data }) => {
  const { updateVenue } = useVenueService();

  const handleUpdate = useCallback(
    async (value, isEditMode, defaultValue) => {
      const historicalNames = data?.historicalNames || [];
      let updated = [];

      if (!isEditMode) {
        updated = [
          ...historicalNames,
          {
            nameLocal: value.nameFullLocal,
            dateStart: value.dateStart,
            dateEnd: value.dateEnd,
          },
        ];
      } else {
        updated = historicalNames.map((item) =>
          item.nameLocal === defaultValue.defaultName &&
          dayjs(item.dateStart).isSame(defaultValue.defaultStartDate) &&
          dayjs(item.dateEnd).isSame(defaultValue.defaultEndDate)
            ? {
                nameLocal: value.nameFullLocal,
                dateStart: value.dateStart,
                dateEnd: value.dateEnd,
              }
            : item,
        );
      }

      //TODO refactor this
      await updateVenue(data.venueId, {
        historicalNames: updated,
      });
    },
    [data, updateVenue],
  );

  const tableColumns = useMemo(() => {
    return columns(data.historicalNames, handleUpdate);
  }, [data, handleUpdate]);

  return (
    <>
      <HistoricNames
        historicalNames={data?.historicalNames}
        columns={tableColumns}
        handleUpdate={handleUpdate}
        modalTitle={"venues.name"}
        permissionName={PersonHistoricNames.VENUE}
      />
    </>
  );
};

export default VenuesHistoricNames;
